import declineErrors from "./declineErrors.json";
import errors from "./errors.json";

type ErrorMap = {
  [key: string]: string
}

export const stripeDeclineErrors = declineErrors as ErrorMap;
export const stripeErrors = errors as ErrorMap;
